import api from "../../../../../../api";
import values from "../../../../../../values";
import Context from "../../../../../../context";
import CustomDropDownSearch from "../../../../../../components/CustomDropDownSearch";

import { useQuery } from "react-query";
import { ICreateStudent } from "../../../../../../types/student.interface";
import {
  CustomButton2,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomView,
} from "../../../../../../components";

import React, { useState } from "react";
import {
  ICompanyItem,
  IOnSearchUser,
} from "../../../../../../types/common.interface";
import { CYCLE } from "../../../../../../values/dropdownItems";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";

type Props = {
  defaultValues: ICreateStudent;
  onSubmit: (event: ICreateStudent) => void;
};

const SuperAgentStudentRelations = (props: Props) => {
  // ** ===========================================================================================================
  // **                                            Values Validation
  // ** -----------------------------------------------------------------------------------------------------------

  let cityInfo: any;

  Cookies.get("city") != "undefined"
    ? (cityInfo = JSON.parse(Cookies.get("city") as string))
    : (cityInfo = undefined);

  const { isLoading } = React.useContext(Context.StudentScreen);

  const [selectedParent, setSelectedParen] = useState<any>(
    props?.defaultValues?.parent
  );
  const [selectedDriver, setSelectedDriver] = useState<any>(
    props?.defaultValues?.driver
  );
  const [selectedSchool, setSelectedSchool] = useState<any>(
    props?.defaultValues?.school
  );
  const [selectedCompany, setSelectedCompany] = useState<any>(
    props?.defaultValues?.company
  );
  const [selectedProvince, setSelectedProvince] = useState<any>({
    _id: cityInfo?.ProvinceId,
  });
  const [selectedCity, setSelectedCity] = useState<any>({
    _id: cityInfo?._id,
  });
  const [selectedCycle, setSelectedCycle] = React.useState<any>(
    props?.defaultValues?.cycle
  );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const [searchedValueParent, setSearchedValueParent] =
    React.useState<IOnSearchUser>();
  const [searchedValueSchool, setSearchedValueSchool] =
    React.useState<IOnSearchUser>();
  const [searchedValueCompany, setSearchedValueCompany] =
    React.useState<IOnSearchUser>();
  const [searchedValueDriver, setSearchedValueDriver] =
    React.useState<IOnSearchUser>();
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    // province: "",
    // city: "",
    company: "",
    parent: "",
    driver: "",
    school: "",
    cycle: "",
  });

  // !! ===========================================================================================================
  // !!                                              REST API Call
  // !! -----------------------------------------------------------------------------------------------------------
  // const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
  //   api.get.common.getAllProvince()
  // );

  const getAllCompany = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.superAgent.findCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      })
  );

  const getAllParent = useQuery(
    ["parent", values.useQueryKeys.getAllParent, searchedValueParent],
    () =>
      api.post.common.findParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      })
  );

  const getAllDriver = useQuery(
    [
      values.useQueryKeys.getAllDriver,
      selectedCompany?._id,
      searchedValueDriver?.searchedValue,
    ],
    () =>
      api.post.superAgent.findDriver({
        search: {
          base: searchedValueDriver?.base.value,
          value: searchedValueDriver?.searchedValue,
        },
      })
  );

  const getAllSchool = useQuery(
    [values.useQueryKeys.getAllSchool, searchedValueSchool?.searchedValue],
    () =>
      api.post.common.findSchoolPost({
        search: {
          base: searchedValueSchool?.base?.value,
          value: searchedValueSchool?.searchedValue,
        },
      })
  );

  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, selectedProvince],
  //   () =>
  //     api.get.common.getAllCity({
  //       provinceCode: selectedProvince?.ProvinceCode,
  //     })
  // );

  // const getAllFinancilalGroup = useQuery(
  //   [values.useQueryKeys?.getAllFinancialGroup],
  //   () =>
  //     api.post.administrator.getAllFinancialGroup({
  //       filters: { FinancialGroupType: "student" },
  //     })
  // );

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const submitHandler = () => {
    let dropDownErrorsList = {
      // province: "",
      // city: "",
      company: "",
      school: "",
      driver: "",
      parent: "",
      cycle: "",
    };
    if (!selectedCompany) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        company: t("company_is_required"),
      };
    }
    if (!selectedSchool) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        school: t("school_is_required"),
      };
    }
    if (!selectedDriver) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        driver: t("driver_is_required"),
      };
    }
    if (!selectedParent) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        parent: t("parent_is_required"),
      };
    }
    if (!selectedCycle) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        cycle: t("cycle_is_required"),
      };
    }

    // if (!selectedProvince) {
    //   dropDownErrorsList = {
    //     ...dropDownErrorsList,
    //     province: "انتخاب استان اجباری است",
    //     city: "انتخاب شهر اجباری است",
    //   };
    // } else if (!selectedCity) {
    //   dropDownErrorsList = {
    //     ...dropDownErrorsList,
    //     city: "انتخاب شهر اجباری است",
    //   };
    // }

    setDropDownErrors(dropDownErrorsList);
    if (
      // selectedProvince &&
      // selectedCity &&
      selectedCompany &&
      selectedDriver &&
      selectedParent &&
      selectedSchool &&
      selectedCycle
    ) {
      props.onSubmit({
        city: selectedCity,
        school: selectedSchool,
        parent: selectedParent,
        driver: selectedDriver,
        company: selectedCompany,
        province: selectedProvince,
        cycle: selectedCycle,
      });
    }
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  const AllParentWithCompleteName = getAllParent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );
  const AllDriverWithCompleteName = getAllDriver?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );
  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );

  const parentPropertyPath =
    values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE.map(
      (item) => {
        switch (item.value) {
          case "PHONE_NUMBER":
            return { ...item, value: "phoneNumber", base: "PHONE_NUMBER" };
          case "FIRST_NAME":
            return { ...item, value: "firstName", base: "FIRST_NAME" };
          case "LAST_NAME":
            return { ...item, value: "lastName", base: "LAST_NAME" };
        }
      }
    );

  const companyPropertyPath =
    values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE.map(
      (item) => {
        switch (item.value) {
          case "COMPANY_NAME":
            return { ...item, value: "companyName", base: "COMPANY_NAME" };
          case "PHONE_NUMBER":
            return { ...item, value: "phoneNumber", base: "PHONE_NUMBER" };
          case "FIRST_NAME":
            return { ...item, value: "firstName", base: "FIRST_NAME" };
          case "LAST_NAME":
            return { ...item, value: "lastName", base: "LAST_NAME" };
          case "NATIONAL_CODE":
            return {
              ...item,
              value: "companyInformation.nationalCode",
              base: "NATIONAL_CODE",
            };
        }
      }
    );
  const driverPropertyPath =
    values.dropdownBaseSearch.DRIVER_BASE_SEARCH_SUPERAGENT.map((item) => {
      switch (item.value) {
        case "PHONE_NUMBER":
          return { ...item, value: "phoneNumber", base: "PHONE_NUMBER" };
        case "FIRST_NAME":
          return { ...item, value: "firstName", base: "FIRST_NAME" };
        case "LAST_NAME":
          return { ...item, value: "lastName", base: "LAST_NAME" };
        case "NATIONAL_CODE":
          return {
            ...item,
            value: "driverInformation.nationalCode",
            base: "NATIONAL_CODE",
          };
      }
    });

  return (
    <form onSubmit={submitHandler}>
      <CustomView.Container className="create-form-content">
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("parent")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.PARENT_BASE_SEARCH_SUPERAGENT.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={AllParentWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedParen(event);
                setDropDownErrors({ ...dropDownErrors, parent: "" });
              }}
              defaultItem={selectedParent}
              searchedValue={searchedValueParent}
              setSearchedValue={setSearchedValueParent}
              placeHolder={t("selectParent")}
              isLoading={getAllParent.isLoading}
              selectedBaseSearch={
                parentPropertyPath.find(
                  (item) => item?.base === searchedValueParent?.base.value
                )?.value
              }
            />
            <div className="error">
              {dropDownErrors.parent !== "" && dropDownErrors.parent}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("school")}</label>

            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SCHOOL_BASE_SEARCH.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={getAllSchool?.data?.result}
              itemName="name"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedSchool(event);
                setDropDownErrors({ ...dropDownErrors, school: "" });
              }}
              defaultItem={selectedSchool}
              searchedValue={searchedValueSchool}
              setSearchedValue={setSearchedValueSchool}
              placeHolder={t("selectSchool")}
              isLoading={getAllSchool.isLoading}
              selectedBaseSearch={searchedValueSchool?.base?.value}
            />
            <div className="error">
              {dropDownErrors.school !== "" && dropDownErrors.school}
            </div>
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("company")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={companyInformationWithCompanyName}
              itemName="companyName"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedCompany(event);
                setDropDownErrors({ ...dropDownErrors, company: "" });
              }}
              defaultItem={selectedCompany}
              searchedValue={searchedValueCompany}
              setSearchedValue={setSearchedValueCompany}
              placeHolder={t("selectCompany")}
              isLoading={getAllCompany.isLoading}
              selectedBaseSearch={
                companyPropertyPath.find(
                  (item) => item?.base === searchedValueCompany?.base?.value
                )?.value
              }
            />
            <div className="error">
              {dropDownErrors.company !== "" && dropDownErrors.company}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("driver")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.DRIVER_BASE_SEARCH_SUPERAGENT.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={AllDriverWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: ICompanyItem) => {
                setDropDownErrors({ ...dropDownErrors, driver: "" });
                setSelectedDriver(event);
              }}
              defaultItem={selectedDriver}
              searchedValue={searchedValueDriver}
              setSearchedValue={setSearchedValueDriver}
              placeHolder={t("selectDriver")}
              isLoading={getAllDriver.isLoading}
              selectedBaseSearch={
                driverPropertyPath.find(
                  (item) => item?.base === searchedValueDriver?.base?.value
                )?.value
              }
            />
            <div className="error">
              {dropDownErrors.driver !== "" && dropDownErrors.driver}
            </div>
          </CustomView.Column>
        </CustomView.Row>

        {/* {(userType === "ADMIN" || userType === "COMPANY") && (
          <CustomView.Row className="form-row">
            <CustomView.Column medium={6} className="form-colum dropdown">
              <label className="form-label">انتخاب استان</label>
              <CustomDropDownSearch
                isSearch
                items={getAllProvince?.data?.result}
                itemName="Name"
                onSelectItem={(event: any) => {
                  setDropDownErrors({ ...dropDownErrors, province: "" });
                  setSelectedProvince(event);
                }}
                placeHolder="انتخاب استان"
                defaultItem={selectedProvince}
                isLoading={getAllProvince.isLoading}
              />
              <div className="error">
                {dropDownErrors.province !== "" && dropDownErrors.province}
              </div>
            </CustomView.Column>
            <CustomView.Column medium={6} className="form-colum dropdown ">
              <label className="form-label">انتخاب شهر</label>
              <CustomDropDownSearch
                isSearch
                items={getAllCity?.data?.result}
                itemName="Name"
                onSelectItem={(event: any) => {
                  setSelectedCity(event);
                  setDropDownErrors({ ...dropDownErrors, city: "" });
                }}
                placeHolder="انتخاب شهر"
                defaultItem={selectedCity}
                isLoading={getAllCity.isLoading}
              />
              <div className="error">
                {dropDownErrors.city !== "" && dropDownErrors.city}
              </div>
            </CustomView.Column>
          </CustomView.Row>
        )} */}
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("serviceFeeCycle")}</label>
            <CustomDropdownSearch
              items={CYCLE.map((item) => ({
                ...item,
                name: t(item.name as string),
              }))}
              itemName="name"
              defaultItem={selectedCycle}
              onSelectItem={(event: any) => {
                setSelectedCycle(event);
                setDropDownErrors({ ...dropDownErrors, cycle: "" });
              }}
              placeHolder={t("selectServiceFeeCycle")}
            />
            <div className="error">
              {dropDownErrors.cycle !== "" && dropDownErrors.cycle}
            </div>
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column
            medium={6}
            className="form-colum submit-button-relation"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={submitHandler}
              title={t("next")}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </form>
  );
};

export default SuperAgentStudentRelations;
